import { CSSObject } from '@emotion/css';

import { mqBreakpoints } from '../..';

const tdStyle: CSSObject = {
  fontSize: '1rem',
  lineHeight: '1.5rem',
  padding: '1rem',
  paddingBottom: '1.5rem',
};

export const tableStyles: CSSObject = {
  '& table': {
    borderCollapse: 'collapse',
    width: '100%',
    marginBottom: '2rem',
    textAlign: 'left',

    '& tr': {
      borderWidth: 0,
      borderTopWidth: '1px',
      borderColor: 'var(--color-border)',
      borderStyle: 'solid',
      '&:first-child': {
        borderTopWidth: '2px',
      },
      '&:last-child': {
        borderBottomWidth: '2px',
      },
    },

    '& th': {
      ...tdStyle,

      [mqBreakpoints.tablet]: {
        fontSize: '1.125rem',
      },
    },

    '& td': {
      ...tdStyle,
    },
  },
};
